export enum DIALOG_TYPES {
  GENERATE_BILLING_REPORT,
  SET_BUDGET_THRESHOLD
}

export enum DATE_TYPES {
  START,
  END
}

export enum TABS {
  SUMMARY,
  INSTANCES,
  VOLUMES,
  OBJECT_STORAGE
}
